module.exports = __webpack_public_path__ + "media/images/credit-card-logo/mastercard-52882103b4038aceb595bdd58cf13e31.svg";